import React from 'react';
import PropTypes from 'prop-types';
import { orderBy } from 'natural-orderby';
import NewsfeedItem from './NewsfeedItem';
import WidgetErrorMessage from '../../WidgetErrorMessage';
import {
    allMetricSourcesAuthorized,
    hasMetricSources,
    getMetricSourceErrors,
    displayMetricSourceError,
    getMetricSourceForRequest,
} from '../../utils/wrapperUtils';

/* eslint-disable complexity */
function getMetricSource({ metricRequests, metrics }) {
    if (metricRequests.length !== 1) {
        return { errorKey: 'invalidMetricRequests' };
    }

    const metricSource = getMetricSourceForRequest(metrics, metricRequests[0]);
    if (!metricSource) {
        return { errorKey: 'metricSourceNotFound' };
    }

    if (!allMetricSourcesAuthorized([metricSource])) {
        return { errorKey: 'metricSourceUnauthorized' };
    }

    if (!hasMetricSources([metricSource], true)) {
        return { errorKey: 'missingData' };
    }

    const metricSourceErrors = getMetricSourceErrors(
        [metricSource],
        metricRequests
    );

    return metricSourceErrors?.length
        ? { metricSourceErrors }
        : { metricSource, metricRequest: metricRequests[0] };
}

export default function NewsfeedWrapper(props) {
    const { metricSource, metricSourceErrors, errorKey } =
        getMetricSource(props);

    if (errorKey) {
        return (
            <WidgetErrorMessage>
                {props.dashboardLabels[errorKey]}
            </WidgetErrorMessage>
        );
    }

    if (metricSourceErrors) {
        return metricSourceErrors.map((error) => (
            <WidgetErrorMessage key={error.uniqueRequestString}>
                {displayMetricSourceError(error, props.dashboardLabels)}
            </WidgetErrorMessage>
        ));
    }

    return (
        <div className="chart-container">
            <div className="newsfeed-container">
                {orderBy(metricSource.metricSeries, 'timestamp', 'desc').map(
                    (dataItem) => (
                        <NewsfeedItem
                            key={`${dataItem.timestamp}${dataItem.message}`}
                            message={dataItem.message}
                            status={dataItem.status}
                            subject={dataItem.subject}
                            timestamp={dataItem.timestamp}
                        />
                    )
                )}
            </div>
        </div>
    );
}
/* eslint-enable complexity */

NewsfeedWrapper.propTypes = {
    dashboardLabels: PropTypes.instanceOf(Object).isRequired,
};
